function getHost(): string {
    if (location.origin) {
        return location.origin;
    }

    // Fix for IE10
    const portSuffix = window.location.port ? ':' + window.location.port : '';

    return window.location.protocol + '//'
        + window.location.hostname
        + portSuffix;
}

const host = getHost();
export default host;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/current-host.ts